import React from 'react';
import Dropdown from '../dropdown/Dropdown';
import styled, { css } from '../../styled';
import * as Tooltip from '../tooltip';
const activeMixin = css `
  background-color: ${({ theme }) => theme.colors.PRIMARY_200};
  & > svg {
    * {
      fill: ${({ theme }) => theme.colors.PRIMARY_700};
    }
  }
`;
const IconSelector = styled.div `
  display: inline-flex;
  padding: 0.25rem;
  border-radius: 4px;
  line-height: 0;

  ${props => props.disabled
    ? css `
          cursor: not-allowed;
          background-color: ${({ theme }) => theme.colors[theme.buttons.types.default.disabledBackgroundColor]};
          > svg {
            * {
              fill: ${({ theme }) => theme.colors[theme.buttons.types.default.disabledTextColor]};
            }
          }
        `
    : css `
          cursor: pointer;
          &:hover {
            background-color: ${({ theme }) => theme.colors.PRIMARY_100};
            & > svg {
              * {
                fill: ${({ theme }) => theme.colors.PRIMARY_600};
              }
            }
            ${({ isOpen }) => isOpen && activeMixin}
          }
          &:active {
            ${activeMixin}
          }
          ${({ isOpen }) => isOpen && activeMixin}
        `};
`;
const StyledDropdown = styled(Dropdown) `
  > div:last-child {
    top: 1.75rem;
    margin-top: 0;
  }
`;
const IconDropDown = ({ isOpen = false, value, options, onSelectorClick, onChange, onClose, disabled = false, menuAlign, tooltipLabel, Icon, iconDirection = 'BOTTOM', tooltipDirection = 'TOP_CENTER', e2eId, }) => {
    const renderSelector = () => {
        const onClick = () => {
            if (!disabled) {
                onSelectorClick();
            }
        };
        return tooltipLabel ? (React.createElement(Tooltip.Primary, { lang: "en", text: tooltipLabel, direction: tooltipDirection },
            React.createElement(IconSelector, { disabled: disabled, onClick: onClick, isOpen: isOpen },
                React.createElement(Icon, { size: "MEDIUM", position: iconDirection })))) : (React.createElement(IconSelector, { disabled: disabled, onClick: onClick, isOpen: isOpen },
            React.createElement(Icon, { size: "MEDIUM", position: iconDirection })));
    };
    return (React.createElement(StyledDropdown, { options: options, isOpen: isOpen, placeHolder: "", value: value, onChange: onChange, onClose: onClose, renderSelector: renderSelector, width: "2.9375rem", menuAlign: menuAlign, e2eId: e2eId }));
};
export default IconDropDown;
//# sourceMappingURL=IconDropdown.js.map